import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "ic-file-input-template",
	templateUrl: "./file-input-template.component.html",
	styleUrls: ["./file-input-template.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FileInputTemplateComponent {
	@Input() file: { filename: string; url: string; key?: string };
	@Input() loading;
	@Input() name: string;

	@Output() download = new EventEmitter();
	@Output() remove = new EventEmitter();
}
